import type { ReactNode } from "react";
import "./DocHeader.css";

/**
 * BELGE KÜNYESİ — form sayfalarının üst şeridi.
 *
 * "Bu ekranda hangi belgeyi, kim, ne zaman, hangi tesis için oluşturuyor?" sorusunu tek
 * bakışta cevaplar. Önce Yeni Sipariş sayfası için yazılmıştı (`.oe-doc`); Yeni Kart
 * sayfası da aynı dili isteyince İKİNCİ BİR KOPYA çıkarmak yerine buraya taşındı —
 * `ghost` buton ezmesinin dört ayrı yerde tekrarlanması dersinden sonra.
 *
 * Yalnız SAYFA (sekme) yerleşiminde kullanılır: çekmecenin kendi başlık şeridi zaten
 * künye görevi görüyor.
 */

export interface DocHeaderProps {
  /**
   * Belge kodu. `null`/boş ise `pending` metni gösterilir — kod sunucuda üretildiği için
   * yeni belgede henüz yoktur ve SAHTE bir kod göstermek yanlış olur.
   */
  code?: string | null;
  /** Kod yokken yazılacak açıklama, örn. "Kod kaydedilince atanır". */
  pending?: string;
  /** Belge türü, örn. "Müşteri Siparişi" / "Stok Kartı". Türden sonra istenirse ` · durum`. */
  kind?: ReactNode;
  /** Alt satır künyesi. `null`/boş öğeler ELENİR → "Oluşturan  · · MAYA FOOD" gibi boş ayraç kalmaz. */
  meta?: (string | null | undefined | false)[];
  /** Sağ blok: durum akışı, rozet vb. */
  right?: ReactNode;
}

export function DocHeader({ code, pending, kind, meta, right }: DocHeaderProps) {
  const metaParcalari = (meta ?? []).filter((m): m is string => !!m && m.trim().length > 0);
  return (
    <div className="doc-head">
      <div className="doc-head-main">
        <div className="doc-head-code">
          {code ? <b>{code}</b> : pending ? <span className="pending">{pending}</span> : null}
          {kind ? <span className="doc-head-kind">{kind}</span> : null}
        </div>
        {metaParcalari.length > 0 ? (
          <div className="doc-head-meta">{metaParcalari.join(" · ")}</div>
        ) : null}
      </div>
      {right}
    </div>
  );
}
